import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//ui components
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Image from './Image';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

//utils
import makeStyles from '@material-ui/core/styles/makeStyles';
import { saveAs } from 'file-saver';

//assets
import Download from '../../../assets/images/download.svg';
import Rotate from '../../../assets/images/rotate-left.svg';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import AlertDialog from '../Dialogs/AlertDialog';
import MessagesContext from '../../../contexts/messagesContext';
import { TrashIcon } from '../Images/Icons';

const useStyle = makeStyles({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    imageContainer: ({ rotationDegree }) => ({
        transform: `rotateZ(${rotationDegree}deg)`,
        transition: 'transform 1s ease',
        background: 'white',
        width: '80%',
        height: '70%',
        maxWidth: '90vh',
        maxHeight: '80vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        '& div': {
            overflow: 'visible',
            cursor: 'grab'
        }
    }),
    image: {
        width: '100%',
        background: 'red',
        minWidth: 400
    },
    actionBar: {
        position: 'fixed',
        bottom: 50,
        right: 50,
        display: 'flex',
        zIndex: 10
    },
    zoomContainer: {
        alignSelf: 'flex-end',
        background: '#333',
        borderRadius: 30,
        position: 'absolute',
        zIndex: 2,
        right: 10,
        bottom: 10,
        height: 45,
        display: 'flex'
    },
    icons: {
        color: '#dadada',
        width: 25,
        height: 25
    }
});
/**
 *
 * @param {{visible: boolean,src: string | string[], handleDelete: () => void,handleDismiss: () => void}} props
 */
export default function ImageShow({ visible = false, src = '', handleDelete, handleDismiss }) {
    const { messages } = useContext(MessagesContext);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [rotationDegree, setRotationDegree] = useState(0);

    const classes = useStyle({ rotationDegree });

    useEffect(() => {
        setRotationDegree((state) => (visible ? state : 0));
    }, [visible]);

    const handleDownload = useCallback(() => {
        saveAs(src);
    }, [src]);

    const handleImageRotation = useCallback(() => {
        setRotationDegree((deg) => (deg - 90) % 360);
    }, []);

    const handleOpenDeleteDialog = useCallback(() => {
        setDeleteDialog(true);
    }, []);
    const handleCloseDeleteDialog = useCallback(() => {
        setDeleteDialog(false);
    }, []);

    return (
        <Modal open={visible} className={classes.container} onClose={handleDismiss}>
            <Fragment>
                <TransformWrapper>
                    {({ zoomIn, zoomOut }) => (
                        <Fragment>
                            <div className={classes.imageContainer}>
                                <TransformComponent className={classes.imageContainer}>
                                    <Image src={src} className={classes.image} />
                                </TransformComponent>
                                <div className={classes.zoomContainer}>
                                    <IconButton onClick={zoomOut} size="medium">
                                        <ZoomOut className={classes.icons} />
                                    </IconButton>
                                    <IconButton onClick={zoomIn} size="medium">
                                        <ZoomIn className={classes.icons} />
                                    </IconButton>
                                </div>
                            </div>

                            <div className={classes.actionBar}>
                                <IconButton onClick={handleOpenDeleteDialog}>
                                    <TrashIcon />
                                </IconButton>
                                <IconButton onClick={handleImageRotation}>
                                    <img src={Rotate} alt="rotate" />
                                </IconButton>
                                <IconButton onClick={handleDownload}>
                                    <img src={Download} alt="download" />
                                </IconButton>
                            </div>
                        </Fragment>
                    )}
                </TransformWrapper>
                <AlertDialog
                    title={messages.alerts.deleteImageTitle}
                    alertText={messages.alerts.deleteImageHint}
                    handleClose={handleCloseDeleteDialog}
                    handleAction={handleDelete}
                    confirmText={messages.yes}
                    cancelText={messages.no}
                    open={deleteDialog}
                />
            </Fragment>
        </Modal>
    );
}

ImageShow.propTypes = {
    visible: PropTypes.bool,
    src: PropTypes.string,
    handleDelete: PropTypes.func,
    handleDismiss: PropTypes.func
};
